import { useQuery } from "@tanstack/react-query";

import { tBooking } from "../types";

import { getBookings } from "../api/getBookings";

export const useGetBookings = () => {
  return useQuery<tBooking[]>({
    queryKey: ["bookings"],
    queryFn: getBookings,
  });
};
